import GAME from './game'

export const SUPPLIER = {
  name: '',
  slug: '',
  tagline: '',
  url: '',
  video_url: '',
  rgb_color_1: '',
  rgb_color_2: '',
  rgb_color_3: '',
  permalink: '',
  popularGame: {
    title: '',
    description: '',
    images: {
      hero: {
        original: '',
        optimized: ''
      },
      background: {
        original: '',
        hero: '',
        hero_sm: '',
      }
    },
    game: GAME
  },
  featuredGames: {
    data: [
      ...GAME
    ]
  },
  images: {
    background: {
      card: '',
      hero: '',
      hero_sm: '',
      original: ''
    },
    desktop_hero_video: {
      original: '',
      thumbnail: ''
    },
    mobile_hero_video: {
      original: '',
      thumbnail: ''
    },
    logo: {
      original: '',
      tiny: '',
      small: '',
      medium: '',
      large: ''
    }
  },
  stats: {
    total_number_of_game_plays: 0,
    total_games: 0
  },
  casinosSummary: {
    data: [
      {
        name: '',
        slug: '',
        images: {
          logo: {
            tiny: ''
          }
        }
      }
    ]
  },
}


// WEBPACK FOOTER //
// ./resources/assets/js/app/store/models/supplier.js